import { render } from "./StatusChangeWidget.vue?vue&type=template&id=6aa1e366"
import script from "./StatusChangeWidget.vue?vue&type=script&lang=js"
export * from "./StatusChangeWidget.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__